<template>
    <div class="alipay-content">
        <van-cell-group>
            <template #title>
                <div class="title">
                    <div class="title-box">
                        <span style="color: black;">支付宝信息</span>
                        <span style="margin-left: 8px; font-size: 11px; color:red">即时到账</span>
                    </div>
                    <div class="title-box">
                        <van-radio-group v-model="radioValue">
                            <van-radio :name="1" @click="setDefault">设为默认</van-radio>
                        </van-radio-group>
                    </div>
                </div>
            </template>
            <van-field v-model="alipay.name" label="姓名" placeholder="请输入支付宝绑定姓名" required :error-message="nameErrMsg"
                @focus="inputFocus" />
            <van-field v-model="alipay.account" label="账号" placeholder="请输入支付宝账号" required
                :error-message="accountErrMsg" @focus="inputFocus" />
        </van-cell-group>
        <div class="form-btn">
            <van-button block type="warning" @click="saveHandler">保 存</van-button>

            <van-button class="delete-btn" block type="danger" :disabled="deleteBtnDisabled" @click="deleteHandler">删 除</van-button>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { createAlipayAccountApi, updateAlipayAccountApi, deleteAccountApi } from 'api/submit'

export default {
    data() {
        return {
            mode: 0,
            emailReg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            cellPhoneReg: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
            radioValue: 0,
            isDefault: false,
            alipay: {
                id: '',
                name: '',
                account: ''
            },
            nameErrMsg: '',
            accountErrMsg: '',
            deleteBtnDisabled: false
        }
    },
    mounted() {
        const mode = this.$route.query.mode
        if (mode === 1) {
            this.mode = 1
            this.alipay.id = this.$route.query.bankId
            this.alipay.name = this.$route.query.accountHolder
            this.alipay.account = this.$route.query.bankAccount
            this.radioValue = this.$route.query.isDefault
        }

    },
    methods: {
        setDefault() {
            if (!this.isDefault) {
                this.isDefault = true
            } else {
                this.radioValue = 0
                this.isDefault = false
            }
        },
        saveHandler() {
            if (this.mode === 0) {
                this.createAlipayAccount()
            } else {
                this.updateAlipayAccount()
            }
        },
        createAlipayAccount() {
            if (!this.validator()) return
            let data = { ...this.alipay, isDefault: this.radioValue }
            createAlipayAccountApi(data).then(({ status, message }) => {
                if (status === 200) {
                    Toast('保存成功')
                    this.$back(-1)
                }
                else if (status === 400) {
                    this.$toast(message)
                } else {
                    this.$toast('网络异常，请稍后再试')
                }
            })
        },
        updateAlipayAccount() {
            if (!this.validator()) return
            console.log('updateAlipayAccount')
            let data = { ...this.alipay, isDefault: this.radioValue }
            updateAlipayAccountApi(data).then(({ status, message}) => {
                if (status === 200) {
                    Toast('保存成功')
                    this.$back(-1)
                }
                else if (status === 400) {
                    this.$toast(message)
                } else {
                    this.$toast('网络异常，请稍后再试')
                }
            })
        },
        deleteHandler() {
            this.$dialog.confirm({
                title: '温馨提示',
                message: '确定删除该账号吗？',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                theme: 'round-button'
            }).then(() => {
                if (this.alipay.id === '') {
                    this.$toast('删除失败[CODE: -1]')
                    return
                }
                console.log(this.alipay)
                this.deleteBtnDisabled = true
                deleteAccountApi(this.alipay.id).then(({ status, message }) => {
                    this.deleteBtnDisabled = false
                    if (status === 200) {
                        Toast('删除成功')
                        this.$back(-1)
                    } else if (status === 400) {
                        this.$toast(message)
                    } else {
                        this.$toast('网络异常，请稍后再试')
                    }
                }).catch(() => {
                    this.deleteBtnDisabled = false
                })
            }).catch(() => {
                // on cancel
            })
        },
        validator() {
            if (this.alipay.name.length === 0) {
                this.nameErrMsg = '请输入姓名'
                return false
            }
            if (this.alipay.account.length === 0) {
                this.accountErrMsg = '请输入账号'
                return false
            } else if (!this.emailReg.test(this.alipay.account) && !this.cellPhoneReg.test(this.alipay.account)) {
                this.accountErrMsg = '支付宝账号格式错误'
                return false
            }
            return true
        },
        inputFocus() {
            this.nameErrMsg = ''
            this.accountErrMsg = ''
        }
    }
}
</script>
<style lang="css" scoped>
.alipay-content {
    padding: 10px;
}

.title {
    display: flex;
    justify-content: space-between;
}

.title-box {
    display: inline-block;
}

.form-btn {
    margin-top: 8px;
}
.delete-btn {
    margin: 15px 0;
}
</style>